import styled from 'styled-components'

const P = styled.p`
  text-align: left;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  color: #999999;
`

export default P